var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCrossEye = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 25.5 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  "data-name": "Group 223326"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Stroke 1",
  d: "M9.845 14.895a4.052 4.052 0 0 1-1.2-2.893 4.1 4.1 0 0 1 7-2.907"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Stroke 3",
  d: "M16.778 12.73a4.1 4.1 0 0 1-3.291 3.3"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Stroke 5",
  d: "M5.816 18.927A17.423 17.423 0 0 1 .75 12.001a17.632 17.632 0 0 1 5.1-6.96 11.071 11.071 0 0 1 6.9-2.514 11.1 11.1 0 0 1 6.922 2.539"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Stroke 7",
  d: "M22.412 7.919A19.925 19.925 0 0 1 24.75 12c-2.552 5.912-7.061 9.473-12 9.473a10.354 10.354 0 0 1-3.285-.536"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Stroke 9",
  d: "M22.982 1.769 2.518 22.233"
}))));
export default SvgCrossEye;